// src/components/layout/Sidebar.js
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import { pageKeys } from '../../utils/pageAccess'; // [marker: permissions-real v1]
const navItems = [
  { section: 'Main' },
  { to: '/',                    icon: '⊞',  label: 'Dashboard' },
  { to: '/members',             icon: '🏢',  label: 'Members' },
  { to: '/contacts',            icon: '👤',  label: 'Contacts' },
  { to: '/events',              icon: '📅',  label: 'Events' },
  { to: '/invoices',            icon: '📄',  label: 'Invoices' },
  { to: '/products',            icon: '📦',  label: 'Item List' }, // [marker: item-list v1]
  { to: '/tasks',               icon: '✅',  label: 'Tasks' },
  { section: 'Finance' },
  { to: '/bookkeeping',         icon: '📒',  label: 'Bookkeeping' },
  { to: '/bookkeeping-reports', icon: '📈',  label: 'Financial Reports' },
  { section: 'Tools' },
  { to: '/reports',             icon: '📊',  label: 'Reports' },
  { to: '/reports/builder',     icon: '🛠️',  label: 'Report Builder' },
  { to: '/settings/forms',      icon: '📋',  label: 'Form Settings' },
  { to: '/promo-codes',         icon: '🎟️',  label: 'Promo Codes' },
  { to: '/event-display',       icon: '🎫',  label: 'Event Display' },
  { to: '/badges',              icon: '🏷',  label: 'Name Tags' }, // [marker: back-tags v1]
  { to: '/website-photos',      icon: '🖼',  label: 'Website Photos' }, // [marker: website-feed v1]
  { to: '/transactions',        icon: '💳',  label: 'Transactions' },
  { to: '/renewals',            icon: '📨',  label: 'Renewals' },
  { to: '/email',               icon: '✉️',  label: 'Email Blasts' },
  { to: '/job-board',           icon: '💼',  label: 'Job Board' }, // [marker: finish-up v1]
  { to: '/email-templates',     icon: '📝',  label: 'Email Templates' },
  { to: '/letters',             icon: '✍️',  label: 'Letters' },
  { to: '/imports',             icon: '📥',  label: 'Import Data' },
  { section: 'System' },
  { to: '/settings',            icon: '⚙️',  label: 'Settings' },
  { to: '/staff',               icon: '👥',  label: 'Staff Users',    adminOnly: true },
  { to: '/permissions',         icon: '🔐',  label: 'Permissions',    adminOnly: true },
];
export default function Sidebar() {
  const { user, logout, isSuperAdmin, can } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => {
    await logout();
    navigate('/login');
    toast.success('Logged out.');
  };
  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <h1>NJJBA</h1>
        <span>Chamber Management</span>
      </div>
      <nav className="sidebar-nav">
        {navItems.map((item, i) => {
          if (item.section) {
            // hide a section heading when nothing under it is visible
            const rest = navItems.slice(i + 1); const end = rest.findIndex(x => x.section);
            const under = (end < 0 ? rest : rest.slice(0, end)).filter(x => !(x.adminOnly && !isSuperAdmin()) && (!pageKeys(x.to) || can(pageKeys(x.to))));
            if (!under.length) return null;
            return <div key={i} className="sidebar-section-label">{item.section}</div>;
          }
          if (item.adminOnly && !isSuperAdmin()) return null;
          { const keys = pageKeys(item.to); if (keys && !can(keys)) return null; } {/* [marker: permissions-real v1] */}
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          );
        })}
      </nav>
      <div className="sidebar-footer">
        <div style={{ fontWeight: 600, color: 'rgba(255,255,255,0.8)', marginBottom: 4 }}>
          {user?.firstName} {user?.lastName}
        </div>
        <div style={{ marginBottom: 10 }}>{user?.role?.replace('_', ' ')}</div>
        <button
          onClick={handleLogout}
          className="btn btn-ghost btn-sm"
          style={{ color: 'rgba(255,255,255,0.6)', padding: '4px 0', width: '100%', justifyContent: 'flex-start' }}
        >
          Sign out
        </button>
      </div>
    </aside>
  );
}
